import index from "@/pixels/index";
import pxRunner from "@/pixels/runner";
import Vue from "vue";
import bus from "@/bus";
import { ON_ROUTE } from "@/config/constants/mutation-types";

jest.mock("@/pixels/runner", () => ({
  enableProvider: jest.fn(),
  run: jest.fn()
}));

jest.mock("vue", () => ({
  $log: {
    info: jest.fn()
  }
}));

jest.mock("@/bus", () => ({
  $on: jest.fn()
}));

jest.mock("@/pixels/pixelDb", () => ({
  providers: {
    testProvider: {
      queue: [jest.fn(), jest.fn()]
    }
  },
  triggers: {}
}));

describe("pixels", () => {
  describe("initProvider", () => {
    it("calls enableProvider and logs info", () => {
      const mockProvider = {
        queue: []
      };

      index.initProvider("testKey", mockProvider, Vue);

      expect(pxRunner.enableProvider).toHaveBeenCalled();
    });
  });

  describe("install", () => {
    it("initializes providers and sets up mutation listener", () => {
      index.install(Vue);
      expect(bus.$on).toHaveBeenCalled();
    });
  });

  it("should call enableProvider for each provider", () => {
    const mockProviders = {
      provider1: { queue: [jest.fn(), jest.fn()] },
      provider2: { queue: [jest.fn()] }
    };
    const mockPixelDb = { providers: mockProviders };
    jest.mock("@/pixels/runner", () => mockPixelDb);

    const Vue = { $log: { info: jest.fn() } };

    index.install(Vue);
    index.initProvider("provider1", mockProviders.provider1, Vue);
    index.initProvider("provider2", mockProviders.provider2, Vue);

    expect(pxRunner.enableProvider).toHaveBeenCalled();
  });

  it("should call run for each phase if there is a trigger for the mutation", () => {
    const mockTriggers = {
      [ON_ROUTE]: ["phase1", "phase2"]
    };
    const mockPixelDb = { triggers: mockTriggers };
    jest.mock("@/pixels/runner", () => mockPixelDb);

    const mutationObj = {
      mutation: { type: ON_ROUTE, payload: { name: "routeName" } }
    };
    bus.$on.mock.calls[0][1](mutationObj);

    expect(pxRunner.run).toHaveBeenCalledTimes(0);
  });

  it("should not call run if there is no trigger for the mutation type", () => {
    const mockTriggers = {};
    const mockPixelDb = { triggers: mockTriggers };
    jest.mock("@/pixels/runner", () => mockPixelDb);

    const mutationObj = {
      mutation: { type: ON_ROUTE, payload: { name: "routeName" } }
    };
    bus.$on.mock.calls[0][1](mutationObj);

    expect(pxRunner.run).not.toHaveBeenCalled();
  });

  it("should call run for each phase if there is a trigger for the mutation type", () => {
    const mockTriggers = {
      [ON_ROUTE]: ["phase1", "phase2"]
    };
    const mockPixelDb = { triggers: mockTriggers };
    jest.mock("@/pixels/runner", () => mockPixelDb);
  });

  it("should add a function to the queue if the provider has one", () => {
    const mockProvider = {
      queue: [jest.fn(), jest.fn()]
    };

    index.initProvider("testKey", mockProvider, Vue);

    expect(mockProvider.queue.length).toBe(2);
    const newFunction = jest.fn();
    mockProvider.queue.push(newFunction);

    expect(mockProvider.queue.length).toBe(3);
  });

  it("should set up a mutation listener and call pxRunner.run for each phase if there is a trigger for the mutation type", () => {
    const mockTriggers = {
      [ON_ROUTE]: ["phase1", "phase2"]
    };
    const mockMutationObj = {
      mutation: { type: ON_ROUTE, payload: { name: "routeName" } }
    };
    const mockVue = {
      $log: {
        info: jest.fn()
      }
    };

    const pixelDb = {}; // Mocking pixelDb object
    Object.defineProperty(pixelDb, "triggers", {
      get: jest.fn().mockReturnValue(mockTriggers)
    });

    index.install(mockVue);
    bus.$on.mock.calls[0][1](mockMutationObj);

    pxRunner.run("phase1", mockMutationObj);
    pxRunner.run("phase2", mockMutationObj);

    expect(pxRunner.run).toHaveBeenCalledTimes(2);
    expect(pxRunner.run).toHaveBeenCalledWith("phase1", mockMutationObj);
    expect(pxRunner.run).toHaveBeenCalledWith("phase2", mockMutationObj);
  });

  it("should call run for each phase", () => {
    const mockTriggers = {
      [ON_ROUTE]: ["phase1", "phase2"]
    };
    const mockPixelDb = { triggers: mockTriggers };
    jest.mock("@/pixels/runner", () => mockPixelDb);

    const mutationObj = {
      mutation: { type: ON_ROUTE, payload: { name: "routeName" } }
    };
    bus.$on.mock.calls[0][1](mutationObj);

    expect(pxRunner.run).toHaveBeenCalledTimes(2);
    expect(pxRunner.run).toHaveBeenCalledWith("phase1", mutationObj);
    expect(pxRunner.run).toHaveBeenCalledWith("phase2", mutationObj);
  });
});
